import { createFileRoute, redirect } from "@tanstack/react-router";

// The Botpress comparison now lives in the unified, translatable comparison
// system at /vs/botpress. Permanent redirect preserves existing links and
// avoids duplicate content.
export const Route = createFileRoute("/vs-botpress")({
  beforeLoad: () => {
    throw redirect({ to: "/vs/$slug", params: { slug: "botpress" }, statusCode: 301 });
  },
});
